import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=16298971&"
import script from "./CalendarIcon.vue?vue&type=script&lang=js&"
export * from "./CalendarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports